import type { Announcement } from '@repo/types';
import { safeGetItem } from '../../lib/utils/localStorage';

/** Valeur d'un <input type="datetime-local"> (heure locale) depuis une date ISO. */
export function isoToLocalInput(iso: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Date ISO depuis un <input type="datetime-local"> ; vide = pas de date. */
export function localInputToIso(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}

export function newAnnouncement(now = new Date()): Announcement {
  const id = typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `a-${now.getTime()}`;
  return { id, message: '', level: 'info', roles: [], starts_at: null, ends_at: null, dismissible: true, updated_at: now.toISOString() };
}

/** Statut affiché dans la liste : programmée, en cours ou terminée. */
export function announcementState(announcement: Announcement, now = new Date()): 'scheduled' | 'active' | 'ended' {
  if (announcement.ends_at && new Date(announcement.ends_at) <= now) return 'ended';
  if (announcement.starts_at && new Date(announcement.starts_at) > now) return 'scheduled';
  return 'active';
}

/** Une annonce masquée revient si le superadmin la modifie (clé = id, valeur = date de modification). */
export const dismissKey = (announcement: Pick<Announcement, 'id'>) => `announcement.dismissed.${announcement.id}`;

export const isDismissed = (announcement: Pick<Announcement, 'id' | 'updated_at' | 'dismissible'>) =>
  announcement.dismissible && safeGetItem(dismissKey(announcement)) === announcement.updated_at;
